function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c3c3c3;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_1-2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M174.69,0a49.42,49.42,0,1,0,49.42,49.41A49.41,49.41,0,0,0,174.69,0Zm0,83.47a34.06,34.06,0,1,1,34.06-34.06A34.06,34.06,0,0,1,174.69,83.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M.08,4.8a1.94,1.94,0,0,1,2-2.55h11.5A3.51,3.51,0,0,1,16.8,4.82l15.83,67c.33,1.42.67,1.36.74,1.36s.43.07.8-1.34l17.68-67a3.63,3.63,0,0,1,3.32-2.55H66.8a3.58,3.58,0,0,1,3.29,2.56l17.19,67c.36,1.4.71,1.34.79,1.34s.41.06.75-1.35l16.33-67a3.53,3.53,0,0,1,3.27-2.56h11.49a1.91,1.91,0,0,1,1.94,2.54L97.23,94a3.68,3.68,0,0,1-3.35,2.54H82.39A3.63,3.63,0,0,1,79.07,94L61.52,27a15,15,0,0,0-.8-2.56A15,15,0,0,0,59.9,27L42,94a3.65,3.65,0,0,1-3.33,2.55H26.89A3.62,3.62,0,0,1,23.58,94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M225.12,4.89a2.64,2.64,0,0,1,2.64-2.64h71.08a2.65,2.65,0,0,1,2.65,2.64v9a2.65,2.65,0,0,1-2.65,2.65h-24.7a2.64,2.64,0,0,0-2.64,2.64V93.94a2.65,2.65,0,0,1-2.65,2.64H257.62A2.65,2.65,0,0,1,255,93.94V19.16a2.64,2.64,0,0,0-2.64-2.64H227.76a2.65,2.65,0,0,1-2.64-2.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M328.68,4.71a4.16,4.16,0,0,1,3.59-2.46h12.29a4.16,4.16,0,0,1,3.59,2.46l34.44,89.41a1.69,1.69,0,0,1-1.7,2.46H368.47A4,4,0,0,1,365,94.09l-7.09-20a4,4,0,0,0-3.52-2.49H322a4,4,0,0,0-3.52,2.49l-7.09,20a4,4,0,0,1-3.52,2.49H296.07a1.69,1.69,0,0,1-1.7-2.46Zm-4,51.86a1.76,1.76,0,0,0,1.77,2.49H350a1.76,1.76,0,0,0,1.77-2.5L339.35,21c-.48-1.37-1-1.29-1.07-1.29s-.59-.08-1.07,1.29Z"
})));

function SvgCompanyLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 382.75 98.83",
    height: "18px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogo);
export default __webpack_public_path__ + "static/media/company_logo.b70d4e49f0df398a56f5d302041aa938.svg";
export { ForwardRef as ReactComponent };